import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue, navy, glass, glowSm, glowMd, transition } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Button', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 4,
      fontWeight: 500,
      letterSpacing: '0.3px',

      // ── Primary：荧光蓝底 + 发光 ──
      [`&${componentCls}-primary`]: {
        [`&:not(${componentCls}-dangerous)`]: {
          background: `${blue[500]} !important`,
          border: `1px solid ${blue[500]} !important`,
          color: `#fff !important`,
          boxShadow: glowSm,

          '&:not(:disabled):hover': {
            background: `${blue[400]} !important`,
            borderColor: `${blue[400]} !important`,
            boxShadow: glowMd,
            transform: 'translateY(-1px)',
          },
          '&:not(:disabled):active': {
            background: `${blue[700]} !important`,
            borderColor: `${blue[700]} !important`,
            transform: 'translateY(0)',
            boxShadow: glowSm,
          },
          '&:disabled': {
            opacity: 0.35,
          },
        },
      },

      // ── Default：深蓝半透明底 + 荧光边框 ──
      [`&${componentCls}-default`]: {
        [`&:not(${componentCls}-dangerous)`]: {
          background: `${glass.input} !important`,
          borderColor: `${navy[700]} !important`,
          color: `#e2e8f0 !important`,

          '&:not(:disabled):hover': {
            borderColor: `${blue[500]}80 !important`,
            color: `${blue[300]} !important`,
            boxShadow: `0 0 8px ${blue[500]}20`,
          },
          '&:not(:disabled):active': {
            borderColor: `${blue[500]} !important`,
          },
        },
      },

      // ── Text / Link ──
      [`&${componentCls}-text, &${componentCls}-link`]: {
        '&:not(:disabled):hover': {
          color: `${blue[400]} !important`,
          background: `${blue[500]}08 !important`,
        },
      },
    },
  }
})
